module.exports = __webpack_public_path__ + "static/media/empresa.96021aca.svg";